<template>
  <div>
    <div class="GeZai_Layer relative">
      <img :src="layer1" :class="$store.getters.hOrV + ' h350'" alt="" />
      <div class="hold-img" :class="$store.getters.hOrV">
        <img :src="layer2($store.state.artwork.layout)" class="h350" alt="" />
        <img
          v-if="$store.state.artwork.format != 'single'"
          :src="layer2($store.state.artwork.rightLayout)"
          class="h350 double"
          alt=""
        />
        <img
          v-if="$store.getters.isTriple"
          :src="layer2($store.state.artwork.tripleRightLayout)"
          class="h350 triple"
          alt=""
        />
      </div>

      <div class="button-img" :class="$store.getters.hOrV">
        <img :src="layer3($store.state.artwork.layout, $store.getters.isVertical ? '_top' : '')" class="h350" alt="" />
        <img
          v-if="$store.state.artwork.format != 'single'"
          :src="layer3($store.state.artwork.rightLayout, $store.getters.isVertical ? '_bottom' : '_no_glare')"
          class="h350 double"
          alt=""
        />
        <img
          v-if="$store.getters.isTriple"
          :src="layer3($store.state.artwork.tripleRightLayout, '_no_glare')"
          class="h350 triple"
          alt=""
        />
      </div>

      <div class="body-img" :class="$store.getters.hOrV">
        <div
          class="table2"
          :class="{
            two: $store.state.artwork.format == 'double',
            vtwo: $store.state.artwork.format == 'vdouble',
            three: $store.state.artwork.format == 'triple',
            vthree: $store.state.artwork.format == 'vtriple',
          }"
        >
          <engraving-elements :elements="layer4" />
          <engraving-elements
            :elements="rightLayer4"
            v-if="$store.state.artwork.format != 'single'"
          />
          <engraving-elements
            :elements="tripleRightLayer4"
            v-if="$store.getters.isTriple"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EngravingElements from "../../../components/EngravingElements.vue";
var albaPositions = {
  icon: {
    small: {
      P1: { x: 7.7, y: 6.5 },
      P2: { x: 7.7, y: 8.3 },
      P3: { x: 7.7, y: 10.1 },
      P4: { x: 21.25, y: 6.5 },
      P5: { x: 21.25, y: 8.3 },
      P6: { x: 21.25, y: 10.1 },
      P7: { x: 14.5, y: 8.3 },
    },
    medium: {
      P1: { x: 9.42, y: 7.36 },
      P2: { x: 9.42, y: 8.3 },
      P3: { x: 9.42, y: 9.09 },
      P4: { x: 19.5, y: 7.36 },
      P5: { x: 19.5, y: 8.3 },
      P6: { x: 19.5, y: 9.09 },
      P7: { x: 14.5, y: 8.3 },
    },
    big: {
      P1: { x: 11, y: 8.3 },
      P2: { x: 11, y: 8.3 },
      P3: { x: 11, y: 8.3 },
      P4: { x: 18, y: 8.3 },
      P5: { x: 18, y: 8.3 },
      P6: { x: 18, y: 8.3 },
      P7: { x: 14.5, y: 8.3 },
    },
  },
  textL1: {
    small: {
      P1: { x: 3.2, y: 3.5 },
      P2: { x: 3.2, y: 7.46 },
      P3: { x: 3.2, y: 11.15 },
      P4: { x: 25.8, y: 3.5 },
      P5: { x: 25.8, y: 7.46 },
      P6: { x: 25.8, y: 11.15 },
      P7: { x: 14.5, y: 7.46 },
    },
    medium: {
      P1: { x: 3.2, y: 3.5 },
      P2: { x: 3.2, y: 6.95 },
      P3: { x: 3.2, y: 10.38 },
      P4: { x: 25.8, y: 3.5 },
      P5: { x: 25.8, y: 6.95 },
      P6: { x: 25.8, y: 10.38 },
      P7: { x: 14.5, y: 6.95 },
    },
    big: {
      P1: { x: 3.2, y: 3.5 },
      P2: { x: 3.2, y: 6.65 },
      P3: { x: 3.2, y: 9.84 },
      P4: { x: 25.8, y: 3.5 },
      P5: { x: 25.8, y: 6.65 },
      P6: { x: 25.8, y: 9.84 },
      P7: { x: 14.5, y: 6.65 },
    },
  },
  textL2: {
    small: {
      P1: { x: 3.2, y: 3.5 },
      P2: { x: 3.2, y: 6.28 },
      P3: { x: 3.2, y: 8.7 },
      P4: { x: 25.8, y: 3.5 },
      P5: { x: 25.8, y: 6.28 },
      P6: { x: 25.8, y: 8.7 },
      P7: { x: 14.5, y: 6.28 },
    },
    medium: {
      P1: { x: 3.2, y: 3.5 },
      P2: { x: 3.2, y: 5.7 },
      P3: { x: 3.2, y: 7.35 },
      P4: { x: 25.8, y: 3.5 },
      P5: { x: 25.8, y: 5.7 },
      P6: { x: 25.8, y: 7.35 },
      P7: { x: 14.5, y: 5.4 },
    },
    big: {
      P1: { x: 3.2, y: 3.5 },
      P2: { x: 3.2, y: 5.1 },
      P3: { x: 3.2, y: 5.95 },
      P4: { x: 25.8, y: 3.5 },
      P5: { x: 25.8, y: 5.1 },
      P6: { x: 25.8, y: 5.95 },
      P7: { x: 14.5, y: 5.1 },
    },
  },
  button: {
    single: {
      K2: [
        { x: 14.4, y: 14.07 },
        { x: 51.6, y: 14.07 },
        { x: 14.4, y: 64.3 },
        { x: 51.6, y: 64.3 },
      ],
      K4: [
        { x: 14.4, y: 14.07 },
        { x: 51.6, y: 14.07 },
        { x: 14.4, y: 30.8 },
        { x: 51.6, y: 30.8 },
        { x: 14.4, y: 47.6 },
        { x: 51.6, y: 47.6 },
        { x: 14.4, y: 64.3 },
        { x: 51.6, y: 64.3 },
      ],
      K8: [
        { x: 14.4, y: 14.07 },
        { x: 51.6, y: 14.07 },
        { x: 14.4, y: 30.8 },
        { x: 51.6, y: 30.8 },
        { x: 14.4, y: 47.6 },
        { x: 51.6, y: 47.6 },
        { x: 14.4, y: 64.3 },
        { x: 51.6, y: 64.3 },
      ],
      M1: [
        { x: 14.25, y: 47.1 },
        { x: 51.4, y: 47.1 },
        { x: 14.25, y: 64.3 },
        { x: 51.4, y: 64.3 },
      ],
      SK: [],
    },
    double: {
      K2: [
        { x: 15.7, y: 14.07 },
        { x: 52.9, y: 14.07 },
        { x: 15.7, y: 64.3 },
        { x: 52.9, y: 64.3 },
      ],
      K4: [
        { x: 15.7, y: 14.07 },
        { x: 52.9, y: 14.07 },
        { x: 15.7, y: 30.8 },
        { x: 52.9, y: 30.8 },
        { x: 15.7, y: 47.6 },
        { x: 52.9, y: 47.6 },
        { x: 15.7, y: 64.3 },
        { x: 52.9, y: 64.3 },
      ],
      K8: [
        { x: 15.7, y: 14.07 },
        { x: 52.9, y: 14.07 },
        { x: 15.7, y: 30.8 },
        { x: 52.9, y: 30.8 },
        { x: 15.7, y: 47.6 },
        { x: 52.9, y: 47.6 },
        { x: 15.7, y: 64.3 },
        { x: 52.9, y: 64.3 },
      ],
      M1: [
        { x: 15.5, y: 47.1 },
        { x: 52.7, y: 47.1 },
        { x: 15.5, y: 64.3 },
        { x: 52.7, y: 64.3 },
      ],
      SK: [],
    },
    vdouble: {
      K2: [
        { x: 14.4, y: 15.4 },
        { x: 51.6, y: 15.4 },
        { x: 14.4, y: 65.7 },
        { x: 51.6, y: 65.7 },
      ],
      K4: [
        { x: 14.4, y: 15.4 },
        { x: 51.6, y: 15.4 },
        { x: 14.4, y: 32.2 },
        { x: 51.6, y: 32.2 },
        { x: 14.4, y: 48.8 },
        { x: 51.6, y: 48.8 },
        { x: 14.4, y: 65.7 },
        { x: 51.6, y: 65.7 },
      ],
      K8: [
        { x: 14.4, y: 15.4 },
        { x: 51.6, y: 15.4 },
        { x: 14.4, y: 32.2 },
        { x: 51.6, y: 32.2 },
        { x: 14.4, y: 48.8 },
        { x: 51.6, y: 48.8 },
        { x: 14.4, y: 65.7 },
        { x: 51.6, y: 65.7 },
      ],
      M1: [
        { x: 14.25, y: 48.7 },
        { x: 51.4, y: 48.7 },
        { x: 14.25, y: 65.9 },
        { x: 51.4, y: 65.9 },
      ],
      SK: [],
    },
    triple: {
      K2: [
        { x: 16.9, y: 14.07 },
        { x: 54.1, y: 14.07 },
        { x: 16.9, y: 64.3 },
        { x: 54.1, y: 64.3 },
      ],
      K4: [
        { x: 16.9, y: 14.07 },
        { x: 54.1, y: 14.07 },
        { x: 16.9, y: 30.8 },
        { x: 54.1, y: 30.8 },
        { x: 16.9, y: 47.6 },
        { x: 54.1, y: 47.6 },
        { x: 16.9, y: 64.3 },
        { x: 54.1, y: 64.3 },
      ],
      K8: [
        { x: 16.9, y: 14.07 },
        { x: 54.1, y: 14.07 },
        { x: 16.9, y: 30.8 },
        { x: 54.1, y: 30.8 },
        { x: 16.9, y: 47.6 },
        { x: 54.1, y: 47.6 },
        { x: 16.9, y: 64.3 },
        { x: 54.1, y: 64.3 },
      ],
      M1: [
        { x: 16.7, y: 47.1 },
        { x: 54.2, y: 47.1 },
        { x: 16.7, y: 64.3 },
        { x: 54.2, y: 64.3 },
      ],
      SK: [],
    },
    vtriple: {
      K2: [
        { x: 14.4, y: 16.6 },
        { x: 51.6, y: 16.6 },
        { x: 14.4, y: 66.8 },
        { x: 51.6, y: 66.8 },
      ],
      K4: [
        { x: 14.4, y: 16.6 },
        { x: 51.6, y: 16.6 },
        { x: 14.4, y: 33.3 },
        { x: 51.6, y: 33.3 },
        { x: 14.4, y: 50.1 },
        { x: 51.6, y: 50.1 },
        { x: 14.4, y: 66.8 },
        { x: 51.6, y: 66.8 },
      ],
      K8: [
        { x: 14.4, y: 16.6 },
        { x: 51.6, y: 16.6 },
        { x: 14.4, y: 33.3 },
        { x: 51.6, y: 33.3 },
        { x: 14.4, y: 50.1 },
        { x: 51.6, y: 50.1 },
        { x: 14.4, y: 66.8 },
        { x: 51.6, y: 66.8 },
      ],
      SK: [],
    }
  },
  rightButton: {
    double: {
      K2: [
        { x: 113.2, y: 14.07 },
        { x: 150.4, y: 14.07 },
        { x: 113.2, y: 64.3 },
        { x: 150.4, y: 64.3 },
      ],
      K4: [
        { x: 113.2, y: 14.07 },
        { x: 150.4, y: 14.07 },
        { x: 113.2, y: 30.8 },
        { x: 150.4, y: 30.8 },
        { x: 113.2, y: 47.6 },
        { x: 150.4, y: 47.6 },
        { x: 113.2, y: 64.3 },
        { x: 150.4, y: 64.3 },
      ],
      K8: [
        { x: 113.2, y: 14.07 },
        { x: 150.4, y: 14.07 },
        { x: 113.2, y: 30.8 },
        { x: 150.4, y: 30.8 },
        { x: 113.2, y: 47.6 },
        { x: 150.4, y: 47.6 },
        { x: 113.2, y: 64.3 },
        { x: 150.4, y: 64.3 },
      ],
      M1: [
        { x: 113, y: 47.1 },
        { x: 150.2, y: 47.1 },
        { x: 113, y: 64.3 },
        { x: 150.2, y: 64.3 },
      ],
      SK: [],
    },
    vdouble: {
      K2: [
        { x: 14.4, y: 112.9 },
        { x: 51.6, y: 112.9 },
        { x: 14.4, y: 163.2 },
        { x: 51.6, y: 163.2 },
      ],
      K4: [
        { x: 14.4, y: 112.9 },
        { x: 51.6, y: 112.9 },
        { x: 14.4, y: 129.7 },
        { x: 51.6, y: 129.7 },
        { x: 14.4, y: 146.4 },
        { x: 51.6, y: 146.4 },
        { x: 14.4, y: 163.2 },
        { x: 51.6, y: 163.2 },
      ],
      K8: [
        { x: 14.4, y: 112.9 },
        { x: 51.6, y: 112.9 },
        { x: 14.4, y: 129.7 },
        { x: 51.6, y: 129.7 },
        { x: 14.4, y: 146.4 },
        { x: 51.6, y: 146.4 },
        { x: 14.4, y: 163.2 },
        { x: 51.6, y: 163.2 },
      ],
      M1: [
        { x: 14.25, y: 146.2 },
        { x: 51.4, y: 146.2 },
        { x: 14.25, y: 163.4 },
        { x: 51.4, y: 163.4 },
      ],
      SK: [],
    },
    triple: { SK: [] },
    vtriple: { SK: [] }

  },
  tripleRightButton: {
    triple : {
      K2: [
        { x: 212.2, y: 14.07 },
        { x: 249.1, y: 14.07 },
        { x: 212.2, y: 64.3 },
        { x: 249.1, y: 64.3 },
      ],
      K4: [
        { x: 212.2, y: 14.07 },
        { x: 249.1, y: 14.07 },
        { x: 212.2, y: 30.8 },
        { x: 249.1, y: 30.8 },
        { x: 212.2, y: 47.6 },
        { x: 249.1, y: 47.6 },
        { x: 212.2, y: 64.3 },
        { x: 249.1, y: 64.3 },
      ],
      K8: [
        { x: 212.2, y: 14.07 },
        { x: 249.1, y: 14.07 },
        { x: 212.2, y: 30.8 },
        { x: 249.1, y: 30.8 },
        { x: 212.2, y: 47.6 },
        { x: 249.1, y: 47.6 },
        { x: 212.2, y: 64.3 },
        { x: 249.1, y: 64.3 },
      ],
      M1: [
        { x: 212, y: 47.1 },
        { x: 249.2, y: 47.1 },
        { x: 212, y: 64.3 },
        { x: 249.2, y: 64.3 },
      ],
      SK: [],
    },
    vtriple: {
      K2: [
        { x: 14.4, y: 211.6 },
        { x: 51.6, y: 211.6 },
        { x: 14.4, y: 261.8 },
        { x: 51.6, y: 261.8 },
      ],
      K4: [
        { x: 14.4, y: 211.6 },
        { x: 51.6, y: 211.6 },
        { x: 14.4, y: 228.3 },
        { x: 51.6, y: 228.3 },
        { x: 14.4, y: 245.1 },
        { x: 51.6, y: 245.1 },
        { x: 14.4, y: 261.8 },
        { x: 51.6, y: 261.8 },
      ],
      K8: [
        { x: 14.4, y: 211.6 },
        { x: 51.6, y: 211.6 },
        { x: 14.4, y: 228.3 },
        { x: 51.6, y: 228.3 },
        { x: 14.4, y: 245.1 },
        { x: 51.6, y: 245.1 },
        { x: 14.4, y: 261.8 },
        { x: 51.6, y: 261.8 },
      ],
      SK: [],
    }
  },
  buttonSize: {
    K2: { height: 11, width: 24 },
    K4: { height: 11, width: 24 },
    K8: { height: 11, width: 24 },
    M1: { height: 11, width: 24 },
  },
  L2offset: {
    small: 2.45,
    medium: 3.15,
    big: 3.85,
  },
  alignment: {
    iconOnly: {
      topleft: { textL1: "", icon: "P2" },
      topcenter: { textL1: "", icon: "P7" },
      topright: { textL1: "", icon: "P5" },
      bottomleft: { textL1: "", icon: "P2" },
      bottomcenter: { textL1: "", icon: "P7" },
      bottomright: { textL1: "", icon: "P5" },
    },
    singleLineText: {
      topleft: { textL1: "P2", icon: "" },
      topcenter: { textL1: "P7", icon: "" },
      topright: { textL1: "P5", icon: "" },
      bottomleft: { textL1: "P2", icon: "" },
      bottomcenter: { textL1: "P7", icon: "" },
      bottomright: { textL1: "P5", icon: "" },
    },
    iconSingleLineText: {
      topleft: { textL1: "P1", icon: "P6" },
      topright: { textL1: "P4", icon: "P3" },
      bottomleft: { textL1: "P3", icon: "P4" },
      bottomright: { textL1: "P6", icon: "P1" },
    },
    doubleLineText: {
      topleft: { textL1: "P2", icon: "" },
      topcenter: { textL1: "P7", icon: "" },
      topright: { textL1: "P5", icon: "" },
      bottomleft: { textL1: "P2", icon: "" },
      bottomcenter: { textL1: "P7", icon: "" },
      bottomright: { textL1: "P5", icon: "" },
    },
    iconDoubleLineText: {
      topleft: { textL1: "P1", icon: "P6" },
      topright: { textL1: "P4", icon: "P3" },
      bottomleft: { textL1: "P3", icon: "P4" },
      bottomright: { textL1: "P6", icon: "P1" },
    },
  },
};

import isBigIconMixin from "../../../mixins/isBigIconMixin";

export default {
  name: "AlbaPanel",
  components: {
    EngravingElements,
  },
  mixins: [isBigIconMixin],
  data() {
    return {
      textL1width: {},
      textL2width: {},
      rtextL1width: {},
      rtextL2width: {},
      frameImgs: {
        yorkBlack: {
          single: { img: "images/collection/faces/gyb_1f.png" },
          double: { img: "images/collection/faces/gyb_2f.png" },
          vdouble: { img: "images/collection/faces/gyb_2f_vertical.png" },
          triple: { img: "images/collection/faces/gyb_3f.png" },
          vtriple: { img: "images/collection/faces/gyb_3f_vertical.png" },
        },
        marsBlack: {
          single: { img: "images/collection/faces/mmb_1f.png" },
          double: { img: "images/collection/faces/mmb_2f.png" },
          vdouble: { img: "images/collection/faces/mmb_2f_vertical.png" },
          triple: { img: "images/collection/faces/mmb_3f.png" },
          vtriple: { img: "images/collection/faces/mmb_3f_vertical.png" },
        },
        aluminiumSilver: {
          single: { img: "images/collection/faces/mas_1f.png" },
          double: { img: "images/collection/faces/mas_2f.png" },
          vdouble: { img: "images/collection/faces/mas_2f_vertical.png" },
          triple: { img: "images/collection/faces/mas_3f.png" },
          vtriple: { img: "images/collection/faces/mas_3f_vertical.png" },
        },
        iceWhite: {
          single: { img: "images/collection/faces/giw_1f.png" },
          double: { img: "images/collection/faces/giw_2f.png" },
          vdouble: { img: "images/collection/faces/giw_2f_vertical.png" },
          triple: { img: "images/collection/faces/giw_3f.png" },
          vtriple: { img: "images/collection/faces/giw_3f_vertical.png" },
        },
        sandWhite: {
          single: { img: "images/collection/faces/gsw_1f.png" },
          double: { img: "images/collection/faces/gsw_2f.png" },
          vdouble: { img: "images/collection/faces/gsw_2f_vertical.png" },
          triple: { img: "images/collection/faces/gsw_3f.png" },
          vtriple: { img: "images/collection/faces/gsw_3f_vertical.png" },
        },
        venetianGold: {
          single: { img: "images/collection/faces/gvg_1f.png" },
          double: { img: "images/collection/faces/gvg_2f.png" },
          vdouble: { img: "images/collection/faces/gvg_2f_vertical.png" },
          triple: { img: "images/collection/faces/gvg_3f.png" },
          vtriple: { img: "images/collection/faces/gvg_3f_vertical.png" },
        },
        bronzeGold: {
          single: { img: "images/collection/faces/mbg_1f.png" },
          double: { img: "images/collection/faces/mbg_2f.png" },
          vdouble: { img: "images/collection/faces/mbg_2f_vertical.png" },
          triple: { img: "images/collection/faces/mbg_3f.png" },
          vtriple: { img: "images/collection/faces/mbg_3f_vertical.png" },
        },
      },

      keyImgs: {
        K2: {
          black: { img: "images/collection/buttons/gyb_2k.png" },
          white: { img: "images/collection/buttons/giw_2k.png" },
          yorkBlack: { img: "images/collection/buttons/gyb_2k.png" },
          iceWhite: { img: "images/collection/buttons/giw_2k.png" },
          sandWhite: { img: "images/collection/buttons/gsw_2k.png" },
          venetianGold: { img: "images/collection/buttons/gvg_2k.png" },
        },
        K4: {
          black: { img: "images/collection/buttons/gyb_4k.png" },
          white: { img: "images/collection/buttons/giw_4k.png" },
          yorkBlack: { img: "images/collection/buttons/gyb_4k.png" },
          iceWhite: { img: "images/collection/buttons/giw_4k.png" },
          sandWhite: { img: "images/collection/buttons/gsw_4k.png" },
          venetianGold: { img: "images/collection/buttons/gvg_4k.png" },
        },
        K8: {
          black: { img: "images/collection/buttons/gyb_8k.png" },
          white: { img: "images/collection/buttons/giw_8k.png" },
          yorkBlack: { img: "images/collection/buttons/gyb_8k.png" },
          iceWhite: { img: "images/collection/buttons/giw_8k.png" },
          sandWhite: { img: "images/collection/buttons/gsw_8k.png" },
          venetianGold: { img: "images/collection/buttons/gvg_8k.png" },
        },
        M1: {
          black: { img: "images/collection/buttons/gyb_m1.png" },
          white: { img: "images/collection/buttons/giw_m1.png" },
          yorkBlack: { img: "images/collection/buttons/gyb_m1.png" },
          iceWhite: { img: "images/collection/buttons/giw_m1.png" },
          sandWhite: { img: "images/collection/buttons/gsw_m1.png" },
          venetianGold: { img: "images/collection/buttons/gvg_m1.png" },
        },
      },
      keyHoleImgs: {
        key248: {
          yorkBlack: "images/collection/cutouts/alba_kp_gyb.png",
          marsBlack: "images/collection/cutouts/alba_kp_mmb.png",
          aluminiumSilver: "images/collection/cutouts/alba_kp_mas.png",
          iceWhite: "images/collection/cutouts/alba_kp_giw.png",
          sandWhite: "images/collection/cutouts/alba_kp_gsw.png",
          venetianGold: "images/collection/cutouts/alba_kp_gvg.png",
          bronzeGold: "images/collection/cutouts/alba_kp_mbg.png",
        },
        keyTT: {
          yorkBlack: "images/collection/cutouts/alba_m1_gyb.png",
          marsBlack: "images/collection/cutouts/alba_m1_mmb.png",
          aluminiumSilver: "images/collection/cutouts/alba_m1_mas.png",
          iceWhite: "images/collection/cutouts/alba_m1_giw.png",
          sandWhite: "images/collection/cutouts/alba_m1_gsw.png",
          venetianGold: "images/collection/cutouts/alba_m1_gvg.png",
          bronzeGold: "images/collection/cutouts/alba_m1_mbg.png",
        },
        keySK: {
          yorkBlack: "images/collection/cutouts/socket_gyb.png",
          marsBlack: "images/collection/cutouts/socket_mmb.png",
          aluminiumSilver: "images/collection/cutouts/socket_mas.png",
          iceWhite: "images/collection/cutouts/socket_giw.png",
          sandWhite: "images/collection/cutouts/socket_gsw.png",
          venetianGold: "images/collection/cutouts/socket_gvg.png",
          bronzeGold: "images/collection/cutouts/socket_mgb.png",
        },
      },
    };
  },
  methods: {
    layer2: function (layout) {
      var frameColor = this.$store.state.artwork.frameColor;

      if (layout == "K2" || layout == "K4" || layout == "K8") {
        return this.keyHoleImgs.key248[frameColor];
      } else if (layout == "M1") {
        return this.keyHoleImgs.keyTT[frameColor];
      } else if (layout == "SK") {
        return this.keyHoleImgs.keySK[frameColor];
      }

      return null;
    },

    layer3: function (layout, lightGlare = "") {
      if (typeof this.keyImgs[layout] != "undefined") {
        return this.keyImgs[layout][
          this.$store.state.artwork.keyColor
        ].img.replace(".png", lightGlare + ".png");
      }
      return "images/collection/sockets/socket_placeholder.png";
    },
    getAlignment(i, alignment = "alignment") {
      if (!this.isBigIcon(i.content)) {
        return this.$store.state.artwork[alignment];
      }
      return this.$store.state.artwork[alignment]
        .replace("left", "center")
        .replace("right", "center");
    },
  },
  created() {
    this.styleMap = this.$store.state.styleMap;
  },
  computed: {
    layer1: function () {
      return this.frameImgs[this.$store.state.artwork.frameColor][
        this.$store.state.artwork.format
      ].img;
    },
    layer4: function () {
      var textSizeLabel =
        this.$store.state.textSizeMap[this.$store.state.artwork.fontSize];
      var alignment = {};
      if (
        typeof albaPositions.alignment[this.$store.state.artwork.layoutStyle] !=
        "undefined"
      ) {
        alignment =
          albaPositions.alignment[this.$store.state.artwork.layoutStyle][
            this.$store.state.artwork.alignment
          ];
      }

      var layoutList = [];

      for (
        var i = 0;
        i <
        albaPositions.button[this.$store.state.artwork.format][
          this.$store.state.artwork.layout
        ].length;
        i++
      ) {
        var lm =
          albaPositions.button[this.$store.state.artwork.format][
            this.$store.state.artwork.layout
          ][i];
        var iconSizeLabel =
          this.$store.state.iconSizeMap[
            this.isBigIcon(this.$store.state.artwork.content[i])
              ? this.$store.state.bigIconSize
              : this.$store.state.artwork.iconSize
          ];

        var o = {
          id: i,
          top: lm.y + 2,
          left: lm.x + 2,
          height:
            albaPositions.buttonSize[this.$store.state.artwork.layout].height,
          width:
            albaPositions.buttonSize[this.$store.state.artwork.layout].width,
          fontSize:
            this.$store.state.fontSizeMap[this.$store.state.artwork.fontSize],
          iconSize: this.isBigIcon(this.$store.state.artwork.content[i])
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.iconSize,
          iconSizeLabel: iconSizeLabel,
          alignment: alignment,
          iconCords: (this.isBigIcon(this.$store.state.artwork.content[i])
            ? albaPositions.icon[iconSizeLabel]["P7"]
            : albaPositions.icon[iconSizeLabel][alignment.icon]) || {
            x: 0,
            y: 0,
          },
          textCords: (this.$store.state.artwork.content[i].hasTextL2
            ? albaPositions.textL2[textSizeLabel][alignment.textL1]
            : albaPositions.textL1[textSizeLabel][alignment.textL1]) || {
            x: 0,
            y: 0,
          },
          textL2Offset: albaPositions.L2offset[textSizeLabel] || 0,
          style: {
            alignment: "middle",
            constrain:
              this.styleMap[this.$store.state.artwork.type][
                this.$store.state.artwork.layout
              ][this.$store.state.artwork.layoutStyle][i],
          },
          content: this.$store.state.artwork.content[i],
        };
        layoutList.push(o);
        this.$store.commit("setAlignment", {
          alignment: this.getAlignment(o),
          index: i,
        });
      }

      return layoutList;
    },
    rightLayer4: function () {
      var textSizeLabel =
        this.$store.state.textSizeMap[this.$store.state.artwork.rightFontSize];
      var alignment = {};
      if (
        typeof albaPositions.alignment[
          this.$store.state.artwork.rightLayoutStyle
        ] != "undefined"
      ) {
        alignment =
          albaPositions.alignment[this.$store.state.artwork.rightLayoutStyle][
            this.$store.state.artwork.rightAlignment
          ];
      }
      var layoutList = [];
      for (
        var i = 0;
        i <
        albaPositions.rightButton[this.$store.state.artwork.format][
          this.$store.state.artwork.rightLayout
        ].length;
        i++
      ) {
        var lm =
          albaPositions.rightButton[this.$store.state.artwork.format][
            this.$store.state.artwork.rightLayout
          ][i];
        var iconSizeLabel =
          this.$store.state.iconSizeMap[
            this.isBigIcon(this.$store.state.artwork.rightContent[i])
              ? this.$store.state.bigIconSize
              : this.$store.state.artwork.rightIconSize
          ];

        var o = {
          id: i,
          top: lm.y + 2,
          left: lm.x + 2,
          height:
            albaPositions.buttonSize[this.$store.state.artwork.rightLayout]
              .height,
          width:
            albaPositions.buttonSize[this.$store.state.artwork.rightLayout]
              .width,
          fontSize:
            this.$store.state.fontSizeMap[
              this.$store.state.artwork.rightFontSize
            ],
          iconSize: this.isBigIcon(this.$store.state.artwork.rightContent[i])
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.rightIconSize,
          iconSizeLabel: iconSizeLabel,
          alignment: alignment,
          iconCords: (this.isBigIcon(this.$store.state.artwork.rightContent[i])
            ? albaPositions.icon[iconSizeLabel]["P7"]
            : albaPositions.icon[iconSizeLabel][alignment.icon]) || {
            x: 0,
            y: 0,
          },
          textCords: (this.$store.state.artwork.rightContent[i].hasTextL2
            ? albaPositions.textL2[textSizeLabel][alignment.textL1]
            : albaPositions.textL1[textSizeLabel][alignment.textL1]) || {
            x: 0,
            y: 0,
          },
          textL2Offset: albaPositions.L2offset[textSizeLabel] || 0,
          style: {
            alignment: "middle",
            constrain:
              this.styleMap[this.$store.state.artwork.type][
                this.$store.state.artwork.rightLayout
              ][this.$store.state.artwork.rightLayoutStyle][i],
          },
          content: this.$store.state.artwork.rightContent[i],
        };

        layoutList.push(o);
        this.$store.commit("setRightAlignment", {
          alignment: this.getAlignment(o, "rightAlignment"),
          index: i,
        });
      }
      return layoutList;
    },
    tripleRightLayer4: function () {
      var textSizeLabel =
        this.$store.state.textSizeMap[
          this.$store.state.artwork.tripleRightFontSize
        ];
      var alignment = {};
      if (
        typeof albaPositions.alignment[
          this.$store.state.artwork.tripleRightLayoutStyle
        ] != "undefined"
      ) {
        alignment =
          albaPositions.alignment[
            this.$store.state.artwork.tripleRightLayoutStyle
          ][this.$store.state.artwork.tripleRightAlignment];
      }
      var layoutList = [];
      for (
        var i = 0;
        i <
        albaPositions.tripleRightButton[this.$store.state.artwork.format][
          this.$store.state.artwork.tripleRightLayout
        ].length;
        i++
      ) {
        var lm =
          albaPositions.tripleRightButton[this.$store.state.artwork.format][
            this.$store.state.artwork.tripleRightLayout
          ][i];
        var iconSizeLabel =
          this.$store.state.iconSizeMap[
            this.isBigIcon(this.$store.state.artwork.tripleRightContent[i])
              ? this.$store.state.bigIconSize
              : this.$store.state.artwork.tripleRightIconSize
          ];

        var o = {
          id: i,
          top: lm.y + 2,
          left: lm.x + 2,
          height:
            albaPositions.buttonSize[
              this.$store.state.artwork.tripleRightLayout
            ].height,
          width:
            albaPositions.buttonSize[
              this.$store.state.artwork.tripleRightLayout
            ].width,
          fontSize:
            this.$store.state.fontSizeMap[
              this.$store.state.artwork.tripleRightFontSize
            ],
          iconSize: this.isBigIcon(
            this.$store.state.artwork.tripleRightContent[i]
          )
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.tripleRightIconSize,
          iconSizeLabel: iconSizeLabel,
          alignment: alignment,
          iconCords: (this.isBigIcon(
            this.$store.state.artwork.tripleRightContent[i]
          )
            ? albaPositions.icon[iconSizeLabel]["P7"]
            : albaPositions.icon[iconSizeLabel][alignment.icon]) || {
            x: 0,
            y: 0,
          },
          textCords: (this.$store.state.artwork.tripleRightContent[i].hasTextL2
            ? albaPositions.textL2[textSizeLabel][alignment.textL1]
            : albaPositions.textL1[textSizeLabel][alignment.textL1]) || {
            x: 0,
            y: 0,
          },
          textL2Offset: albaPositions.L2offset[textSizeLabel] || 0,
          style: {
            alignment: "middle",
            constrain:
              this.styleMap[this.$store.state.artwork.type][
                this.$store.state.artwork.tripleRightLayout
              ][this.$store.state.artwork.tripleRightLayoutStyle][i],
          },
          content: this.$store.state.artwork.tripleRightContent[i],
        };

        layoutList.push(o);
        this.$store.commit("setTripleRightAlignment", {
          alignment: this.getAlignment(o, "tripleRightAlignment"),
          index: i,
        });
      }
      return layoutList;
    },
  },
};
</script>
